import { apiService } from './api';
import {
  PendingEntry,
  ChangeProposal,
  WorkflowQuery,
  ReviewRequest,
  WorkflowResponse,
  MyAssignmentsResponse,
  MySubmissionsResponse,
} from '../types/workflow';

export const workflowService = {
  // Get pending entries
  async getPendingEntries(query?: WorkflowQuery): Promise<WorkflowResponse<PendingEntry>> {
    const params = new URLSearchParams();
    if (query?.status) params.append('status', query.status);
    if (query?.entityType) params.append('entityType', query.entityType);
    if (query?.assignedTo) params.append('assignedTo', query.assignedTo);
    if (query?.submittedBy) params.append('submittedBy', query.submittedBy);
    if (query?.page) params.append('page', query.page.toString());
    if (query?.limit) params.append('limit', query.limit.toString());

    const queryString = params.toString();
    const url = queryString ? `/api/workflow/pending-entries?${queryString}` : '/api/workflow/pending-entries';
    
    const response = await apiService.get<WorkflowResponse<PendingEntry>>(url);
    return response.data;
  },

  // Get change proposals
  async getChangeProposals(query?: WorkflowQuery): Promise<WorkflowResponse<ChangeProposal>> {
    const params = new URLSearchParams();
    if (query?.status) params.append('status', query.status);
    if (query?.entityType) params.append('entityType', query.entityType);
    if (query?.assignedTo) params.append('assignedTo', query.assignedTo);
    if (query?.submittedBy) params.append('submittedBy', query.submittedBy);
    if (query?.page) params.append('page', query.page.toString());
    if (query?.limit) params.append('limit', query.limit.toString());

    const queryString = params.toString();
    const url = queryString ? `/api/workflow/change-proposals?${queryString}` : '/api/workflow/change-proposals';
    
    const response = await apiService.get<WorkflowResponse<ChangeProposal>>(url);
    return response.data;
  },

  // Review pending entry
  async reviewPendingEntry(id: string, review: ReviewRequest): Promise<PendingEntry> {
    const response = await apiService.put<PendingEntry>(`/api/workflow/pending-entries/${id}/review`, review);
    return response.data;
  },

  // Review change proposal
  async reviewChangeProposal(id: string, review: ReviewRequest): Promise<ChangeProposal> {
    const response = await apiService.put<ChangeProposal>(`/api/workflow/change-proposals/${id}/review`, review);
    return response.data;
  },

  // Assign pending entry
  async assignPendingEntry(id: string, assignedTo: string): Promise<PendingEntry> {
    const response = await apiService.put<PendingEntry>(`/api/workflow/pending-entries/${id}/assign`, { assignedTo });
    return response.data;
  },

  // Assign change proposal
  async assignChangeProposal(id: string, assignedTo: string): Promise<ChangeProposal> {
    const response = await apiService.put<ChangeProposal>(`/api/workflow/change-proposals/${id}/assign`, { assignedTo });
    return response.data;
  },

  // Get my assignments
  async getMyAssignments(query?: WorkflowQuery): Promise<MyAssignmentsResponse> {
    const params = new URLSearchParams();
    if (query?.status) params.append('status', query.status);
    if (query?.entityType) params.append('entityType', query.entityType);
    if (query?.page) params.append('page', query.page.toString());
    if (query?.limit) params.append('limit', query.limit.toString());

    const queryString = params.toString();
    const url = queryString ? `/api/workflow/my-assignments?${queryString}` : '/api/workflow/my-assignments';
    
    const response = await apiService.get<MyAssignmentsResponse>(url);
    return response.data;
  },

  // Get my submissions
  async getMySubmissions(query?: WorkflowQuery): Promise<MySubmissionsResponse> {
    const params = new URLSearchParams();
    if (query?.status) params.append('status', query.status);
    if (query?.entityType) params.append('entityType', query.entityType);
    if (query?.page) params.append('page', query.page.toString());
    if (query?.limit) params.append('limit', query.limit.toString());

    const queryString = params.toString();
    const url = queryString ? `/api/workflow/my-submissions?${queryString}` : '/api/workflow/my-submissions';
    
    const response = await apiService.get<MySubmissionsResponse>(url);
    return response.data;
  },
};
